import React, { useEffect, useState } from "react";
import * as MyCells from '../../../../../utils/Cells';

const SalaryAggregatePanel = (props) => {
    const [rows, setRows] = useState([]);

    useEffect(() => {
        // console.log(props);
        setRows(props.rows);
    }, [props]);

    function getSize() {
        return rows.length;
    }

    function getNet() {
        return rows.reduce((a, b) => a + (b.original.netSalary || 0), 0)
    }

    function getReduced() {
        return rows.reduce((a, b) => a + (b.original.restrainReducedSalary || 0), 0)
    }

    return (
        <div className="aggregate-data">
            <span>Sorok száma: {getSize()}</span>
            <span> Nettó: {<MyCells.NumberCell value={getNet()} />}</span>
            <span> Levonásokkal csökkentett: {<MyCells.NumberCell value={getReduced()} />}</span>
        </div>
    );
};

export default SalaryAggregatePanel;